import React, { useMemo } from 'react';
import { Button } from 'reactstrap';
import type { CustomerState } from '../types/customer-states.types';
import CustomerStateBadge from './CustomerStateBadge';
import TableContainer from '../../../Components/Common/TableContainer';

type CustomerStateTableProps = {
    data: CustomerState[];
    total: number;
    onPageChange: (page: number) => void;
    isLoading: boolean;
    onEdit: (state: CustomerState) => void;
    onDeactivate: (state: CustomerState) => void;
    onTransitions?: (state: CustomerState) => void;
};

export const CustomerStateTable: React.FC<CustomerStateTableProps> = ({
    data,
    total,
    onPageChange,
    isLoading,
    onEdit,
    onDeactivate,
    onTransitions,
}) => {
    const columns = useMemo(
        () => [
            {
                header: "Nombre",
                accessorKey: "name",
                enableColumnFilter: false,
            },
            {
                header: "Tipo",
                accessorKey: "type",
                enableColumnFilter: false,
                cell: (cellProps: any) => {
                    const type = cellProps.getValue();
                    return <CustomerStateBadge state={{ type }} />;
                },
            },
            {
                header: "Descripción",
                accessorKey: "description",
                enableColumnFilter: false,
                cell: (cellProps: any) => {
                    const description = cellProps.getValue();
                    return description ? (
                        <span className="text-wrap" style={{ maxWidth: '250px', display: 'inline-block' }}>
                            {description}
                        </span>
                    ) : (
                        <span className="text-muted fs-12 italic">-</span>
                    );
                },
            },
            {
                header: "Acciones",
                enableColumnFilter: false,
                cell: (cell: any) => {
                    const state = cell.row.original;
                    const isInitial = state.type === 'INITIAL';
                    return (
                        <div className="text-end">
                            <Button
                                className="btn btn-info btn-sm me-1"
                                onClick={() => onTransitions && onTransitions(state)}
                            >
                                <i className="ri-route-line"></i>
                            </Button>
                            <Button
                                className="btn btn-warning btn-sm me-1"
                                onClick={() => onEdit(state)}
                                title="Editar"
                            >
                                <i className="ri-pencil-fill"></i>
                            </Button>
                            <Button
                                className="btn btn-danger btn-sm"
                                onClick={() => onDeactivate(state)}
                                disabled={isInitial}
                                title="Desactivar"
                            >
                                <i className="ri-delete-bin-fill"></i>
                            </Button>
                        </div>
                    );
                },
            },
        ],
        [onEdit, onDeactivate, onTransitions]
    );

    return (
        <TableContainer
            columns={columns}
            data={data}
            isGlobalFilter={false}
            customPageSize={10}
            total={total}
            onPageChange={onPageChange}
            divClass="table-responsive table-card mb-3"
            tableClass="align-middle table-nowrap mb-0"
            theadClass="table-light"
            isLoading={isLoading}
            isFetching={isLoading}
        />
    );
};

export default CustomerStateTable;
